import { render, staticRenderFns } from "./BallTool.vue?vue&type=template&id=97230290&scoped=true&"
import script from "./BallTool.vue?vue&type=script&lang=js&"
export * from "./BallTool.vue?vue&type=script&lang=js&"
import style0 from "./BallTool.vue?vue&type=style&index=0&id=97230290&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97230290",
  null
  
)

export default component.exports